angular.module('tgaAdmin')
  .controller('GameRecallController', [
    '$scope', '$timeout', 'modalService', '$filter',
    function (
      $scope, $timeout, modalService, $filter,
    ) {
      $scope.data.questionTypes = [
        {
          id: 'multiple_choice',
          name: 'Multiple Choice',
        }, {
          id: 'multiple_select',
          name: 'Multiple Select',
        }, {
          id: 'text_input',
          name: 'Text Input',
        }, {
          id: 'poll',
          name: 'Poll',
        },
      ];

      $scope.data.matchTypes = [{
        id: null,
        name: 'Exact',
      }, {
        id: 'contains',
        name: 'Contains',
      }, {
        id: 'starts_with',
        name: 'Starts With',
      }, {
        id: 'ends_with',
        name: 'Ends With',
      }, {
        id: 'inside',
        name: 'Inside',
      }];

      $scope.questionTooltip = $filter('translate')('common.question_tooltip_html');

      $scope.actions.addQuestionGroup = function () {
        $scope.gameForm.$setDirty();
        $scope.data.limit = 500;

        const question_group = {
          name: null,
          useTimer: true,
          question_group_id: null,
          question_group_type: 'multiple_choice',
          text: null,
          image: null,
          audio: null,
          video: null,
          time: 60,
          randomize_questions: true,
          questions: [],
          max_questions: 10,
          translations: {},
          isOpen: [],
        };

        $scope.viewmodel.game.question_groups.push(question_group);
        $scope.actions.toggleCollapse($scope.viewmodel.game.question_groups.length - 1);
      };

      $scope.actions.deleteQuestionGroup = function (group) {
        if (group.question_group_id === null) {
          $scope.gameForm.$setDirty();
          $scope.viewmodel.game.question_groups.splice($scope.viewmodel.game.question_groups.indexOf(group), 1);
          return;
        }

        modalService.showModal({
          title: 'Delete Question Group?',
          // eslint-disable-next-line max-len
          message: 'Are you sure you want to delete this question group? All analytics data associated with the question will be permanently deleted.',
          closeButton: 'No',
          actionButton: 'Yes',
        }, {
          backdrop: true,
          keyboard: true,
          animation: false,
        }).then(() => {
          $scope.gameForm.$setDirty();
          $scope.viewmodel.game.question_groups.splice($scope.viewmodel.game.question_groups.indexOf(group), 1);
          $scope.data.isOpen.length = 0;
        }, () => { });
      };

      $scope.actions.moveQuestionGroup = function (from, to) {
        $scope.gameForm.$setDirty();
        $scope.viewmodel.game.question_groups.splice(to, 0, $scope.viewmodel.game.question_groups.splice(from, 1)[0]);

        if ($scope.data.isOpen[from]) {
          $scope.data.isOpen.length = 0;
          $scope.data.isOpen[to] = true;
        } else if ($scope.data.isOpen[to]) {
          $scope.data.isOpen.length = 0;
          $scope.data.isOpen[from] = true;
        }
      };

      $scope.actions.moveQuestionInGroup = function (group, from, to) {
        $scope.gameForm.$setDirty();
        group.questions.splice(to, 0, group.questions.splice(from, 1)[0]);

        if (angular.isUndefined(group.isOpen)) {
          group.isOpen = [];
        }

        if (group.isOpen[from]) {
          group.isOpen.length = 0;
          group.isOpen[to] = true;
        } else if (group.isOpen[to]) {
          group.isOpen.length = 0;
          group.isOpen[from] = true;
        }
      };

      $scope.actions.addQuestionToGroup = function (group, g_index) {
        $scope.gameForm.$setDirty();
        const question = {
          question_id: null,
          question_type: 'multiple_choice',
          question_group: null,
          text: null,
          image: null,
          audio: null,
          video: null,
          points_correct: null,
          points_incorrect: null,
          response_correct: null,
          response_incorrect: null,
          response_timeout: null,
          time: $scope.viewmodel.game.time_per_question,
          randomize_answers: true,
          show_results: null,
          answers: [{
            answer_id: null,
            text: null,
            image: null,
            response: null,
            correct: false,
            points: null,
            match_type: null,
          }, {
            answer_id: null,
            text: null,
            image: null,
            response: null,
            correct: false,
            points: null,
            match_type: null,
          }],
          translations: {},
        };

        $scope.actions.changeQuestionType(question);
        group.questions.push(question);
        $scope.actions.toggleQuestionCollapse(group, g_index, group.questions.length - 1);
      };

      $scope.actions.deleteQuestionFromGroup = function (group, question) {
        if (question.question_id === null) {
          $scope.gameForm.$setDirty();
          group.questions.splice(group.questions.indexOf(question), 1);
          return;
        }

        modalService.showModal({
          title: 'Delete Question?',
          // eslint-disable-next-line max-len
          message: 'Are you sure you want to delete this question? All analytics data associated with the question will be permanently deleted.',
          closeButton: 'No',
          actionButton: 'Yes',
        }, {
          backdrop: true,
          keyboard: true,
          animation: false,
        }).then(() => {
          $scope.gameForm.$setDirty();
          group.questions.splice(group.questions.indexOf(question), 1);
          group.isOpen.length = 0;
        }, () => { });
      };

      $scope.actions.toggleQuestionCollapse = function (group, g_index, q_index) {
        if (angular.isUndefined(group.isOpen)) {
          group.isOpen = [];
        }

        if (group.isOpen[q_index]) {
          group.isOpen.length = 0;
          return;
        }

        group.isOpen.length = 0;
        group.isOpen[q_index] = true;
        $timeout(() => {
          $('html, body').stop(true, false).animate({
            scrollTop: $('#parent-group').children('.panel').eq(g_index).find('.panel')
              .eq(q_index)
              .offset().top - 120,
          }, 250);
        }, 10);
      };

      $scope.actions.verifyQuestionGroups = function () {
        for (let i = 0; i < $scope.viewmodel.game.question_groups.length; i++) {
          if ($scope.viewmodel.game.question_groups[i].image === null && $scope.viewmodel.game.question_groups[i].video === null) {
            $scope.viewmodel.game.question_groups[i].has_error = true;
          } else {
            $scope.viewmodel.game.question_groups[i].has_error = false;
          }
        }

        $scope.actions.checkGameForm();
      };
    }]);
